<nz-radio-group [(ngModel)]="projectOpt" [name]="name" (ngModelChange)="onProjectOptChange($event)">
  <label nz-radio style="width: 120px;" nzValue='-2' *ngIf="!isProjectRestricted">All Projects</label>
  <label nz-radio style="width: 120px;" nzValue='1' *ngIf="!isProjectRestricted">No Project</label>
  <label nz-radio style="width: 120px;" nzValue='2'>Main Project</label>
  <label nz-radio style="width: 120px;" nzValue='3'>Sub Project</label>
</nz-radio-group>

